import React from "react";

type TableDataProps = {
	children?: JSX.Element | string | number;
	className?: string;
	available?: boolean;
};

const TableData = ({
	children,
	className,
	available = true,
}: TableDataProps) => {
	return (
		<td
			className={`table-data ${children || "hidden"} ${
				available || "hidden"
			} ${className}`}
			children={children}
		></td>
	);
};

TableData.defaultProps = { available: true, className: "" };

export default TableData;
